// extracted by mini-css-extract-plugin
module.exports = {"backLink":"style-module--backLink--1pTLz","backLinkHeadline":"style-module--backLinkHeadline--2Z4Tj"};